import { ResetPasswordFormCard } from "@/features/auth/components/reset-password-form-card";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/auth/reset-password")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex items-center justify-center min-h-screen p-4 sm:p-0">
      <ResetPasswordFormCard />
    </div>
  );
}
